export const GraphColor = {
    'TTM': '#0000FF',
    'IMS': '#000000',
    'MDR': '#964B00',
    //Quota : '#FF9800',
    'LE Diagnostics': 'green',
    //InitialQuota : '#F57C00',
    'Month': '#800080',
    'Local': '#a206a2',
    'Local2': '#c152c1',
    'Local3': '#d099d0',
    "Ex-Factory": "#3366cc",
    "DeliveredQTY": "#ADD8E6",
    "IQVIA - MIDAS": "#000000",
    SIT: "purple",
    Forecast: "green",
    "AI Forecast":"#EC5066",
    "Quota": "orange",
    "Original Quota": "red",
    "Initial Quota": "red",
    "Final Quota": "#FFD700",
    "Consensus FC": "#74b72e",
    "SK Wholesalers sales": "#39a78e",
    "GERS":"#a0a0a0"
}

export const LocalGraphColor = ["#FDAB9F", "#bebdb8", "#bdb7ab", "#d9dddc", "#FE7D6A", "#d6cfc7", "#c7c6c1", "#FC9483", "#999da0", "#FC4C4E", "#4c3228", "#8b6c5c", "#d8cbc4", "#7600bc", "#6a4a3a", "#ca5cdd", "#bca89f", "#be2ed6", "#da8ee7", "#a000c8", "#9E4244", "#777b7e", "#793F0D", "#AC703D", "#C38E63", "#E49969", "#E5AE86", "#EEC5A9", "#9D9754", "#C7C397", "#B4A851", "#DFD27C", "#E7E3B5", "#846D74", "#B7A6AD", "#D3C9CE", "#d8bfd8", "#dda0dd", "#da70d6", "#ffc0cb", "#db7094", "#ffb6c1", "#915f6d", "#2c5e5d", "#4a9e9b", "#6eb1af", "#92c4c3", "#b6d8d7", "#428e8b", "#5c8caf", "#9dbacf", "#49708c"];
